import { createApi } from '@reduxjs/toolkit/query/react';
import { urls } from '../../utils/helpers/ApiClient';
import axiosFetchBase from '../axiosFetchBase';

export const fjClickStatsApi = createApi({
  reducerPath: 'fjClickStatsApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosFetchBase,
  endpoints: (builder) => ({
    clickOnJob: builder.mutation({
      query(req) {
        return {
          url: `${urls.friJobsClickStats}`,
          method: 'POST',
          data: req,
        };
      },
    }),
  }),
});

export const { useClickOnJobMutation } = fjClickStatsApi;
